import { fn } from '@common/utils';
import { Observable } from '../navdata';

/** Infa windows service Utility */
export class InfWindowService extends Observable {
    static $inject = ["$window", "$rootScope"];
    constructor(public $window: ng.IWindowService, private $rootScope: ng.IRootScopeService) {
        super();
    }
    private onResize: () => void;

    private ensureActive() {
        if (this.onResize)
            return;
        var $rootScope = this.$rootScope;
        var me = this;
        this.onResize = fn.debounce(() => {
            me.trigger("resize");
            if (!$rootScope.$$phase)
                $rootScope.$applyAsync();
        }, 50);

        $(this.$window).resize(this.onResize);
        $rootScope.$on("$destroy", () => $(window).off("resize"));
    }
    /** Register Size Changed
    * - If el is part of a Kendo Window- kendo window change gets taken into account!
    * - Gets Automatically Deregistered with given Scopes Destroy event
    * - return value can be used to explicitly dereigister
    */
    public RegisterResizeChanged(cb: () => void, el: JQuery, $scope?: ng.IScope) {
        this.ensureActive();
        var me = this;
        super.bind("resize", cb);

        var kendoWindow = <kendo.ui.Window>(
          el && $(el)
            .parents()
            .filter(function () {
              return $(this).data("kendoWindow") !== undefined;
            })
            .first()
            .data("kendoWindow")
        );

        if (kendoWindow) {
            var kAction = () => { cb(); this.onResize(); };
            kendoWindow.bind("resize", kAction);
        }

        var result = () => {
            me.unbind("resize", cb);
            if (kendoWindow) {
                kendoWindow.unbind("resize", kAction);
                kendoWindow = null;
            }
        };
        if ($scope)
            $scope.$on("$destroy", result);
        return result;
    }
}
